import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

function getValorMostrar(registro, indice, valorMostrar_, valorNull) {
   let valor;
   let valorMostrar;
   if (typeof valorMostrar_ === 'string') {
      valor = registro[valorMostrar_];
   } else {
      valor = valorMostrar_(registro, indice);
   }
   if (valor === null) {
      if (valorNull !== undefined && valorNull !== null) {
         valorMostrar = valorNull;
      } else {
         valorMostrar = valor;
      }
   } else {
      valorMostrar = valor.toString();
   }
   return [valor, valorMostrar];
}

function funcionVacia() {}

function BandaDatos(props) {
   const {
      registros,
      campos,
      registro,
      campo,
      procesarRegistro,
      nroRegistrosMostrar,
      offset
   } = props;
   const propsRegFuncion = registro.props instanceof Function;
   const propsCampoFuncion = campo.props instanceof Function;

   const [registrosMostrar, setRegistrosMostrar] = useState([]);

   useEffect(() => {
      setRegistrosMostrar(registros);
   }, [registros]);

   useEffect(() => {
      if (offset < 0) {
         setRegistrosMostrar(registros);
      } else {
         const auxArr = registros.slice(offset, nroRegistrosMostrar + offset);
         setRegistrosMostrar(auxArr);
      }
   }, [offset]);

   return (
      <>
         {registrosMostrar.map((reg, index) => {
            const registroProps = propsRegFuncion ? registro.props(reg) : registro.props;
            if (procesarRegistro) {
               procesarRegistro(reg);
            }
            return (
               <registro.componente key={index} registro={reg} {...registroProps}>
                  {campos.map((item, indexCampo) => {
                     const campoProps = propsCampoFuncion
                        ? campo.props(item.nombre, reg)
                        : campo.props;
                     const valor = getValorMostrar(
                        reg,
                        index + offset,
                        item.valorMostrar,
                        item.valorNullMostrar
                     );
                     //Realizar resumen
                     return (
                        <campo.componente
                           key={indexCampo}
                           valor={valor[0]}
                           titulo={item.titulo}
                           nombreCampo={item.nombre}
                           {...campoProps}
                           {...item.props}
                           registro={reg}
                        >
                           {valor[1]}
                        </campo.componente>
                     );
                  })}
               </registro.componente>
            );
         })}
      </>
   );
}

BandaDatos.propTypes = {
   registros: PropTypes.arrayOf(PropTypes.object).isRequired,
   campos: PropTypes.arrayOf(
      PropTypes.shape({
         nombre: PropTypes.string.isRequired,
         titulo: PropTypes.string,
         valorMostrar: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
         valorNullMostrar: PropTypes.string,
         props: PropTypes.object
      })
   ).isRequired,
   registro: PropTypes.shape({
      componente: PropTypes.elementType.isRequired,
      props: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
   }).isRequired,
   campo: PropTypes.shape({
      componente: PropTypes.elementType.isRequired,
      props: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
   }).isRequired,
   procesarRegistro: PropTypes.func
};

export default BandaDatos;
